(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7235],{

/***/ 26010:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legal/cookies",
      function () {
        return __webpack_require__(42278);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 59679:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Lead; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./src/components/Paragraph/index.js + 1 modules
var Paragraph = __webpack_require__(19296);
;// CONCATENATED MODULE: ./src/components/Lead/Lead.js




var defaultProps = {
    muted: true,
    className: null
};
var propTypes = {
    muted: (prop_types_default()).bool,
    className: (prop_types_default()).string,
    children: (prop_types_default()).node.isRequired
};
function Lead(param) {
    var muted = param.muted, className = param.className, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
        className: (0,clsx_m/* default */.Z)("text-lg font-normal leading-normal lg:text-xl", muted && "text-gray-600", className),
        children: children
    });
};
Lead.defaultProps = defaultProps;
Lead.propTypes = propTypes;

;// CONCATENATED MODULE: ./src/components/Lead/index.js

/* harmony default export */ var components_Lead = (Lead);


/***/ }),

/***/ 19296:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Paragraph; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./src/components/Paragraph/Paragraph.js





var defaultProps = {
    className: "",
    children: null
};
var propTypes = {
    className: (prop_types_default()).string,
    children: (prop_types_default()).node
};
function Paragraph(_param) {
    var className = _param.className, children = _param.children, otherProps = (0,_object_without_properties/* default */.Z)(_param, [
        "className",
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: className
    }, otherProps), {
        children: children
    }));
};
Paragraph.defaultProps = defaultProps;
Paragraph.propTypes = propTypes;

;// CONCATENATED MODULE: ./src/components/Paragraph/index.js

/* harmony default export */ var components_Paragraph = (Paragraph);


/***/ }),

/***/ 86402:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ LegalLayout; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(86010);
/* harmony import */ var _components_Container__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30341);
/* harmony import */ var _components_Lead__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59679);
/* harmony import */ var _components_Link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48300);
/* harmony import */ var _BasicLayout__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8546);








function LegalNavigationLink(param) {
    var href = param.href, isActive = param.isActive, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Link__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        href: href,
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("inline-flex py-2", isActive === true && "pointer-events-none font-medium text-gray-900", isActive === false && "text-gray-500 hover:text-gray-900 transition ease-in-out duration-300"),
        children: children
    });
}
var defaultProps = {};
var propTypes = {
    pageTitle: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string.isRequired),
    children: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().node.isRequired)
};
function LegalLayout(param) {
    var pageTitle = param.pageTitle, children = param.children;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_BasicLayout__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "bg-gradient-to-tl from-green-100 to-green-50 py-10 lg:py-20",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Container__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex flex-col items-center text-center space-y-4",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                className: "text-xl lg:text-5xl font-semibold tracking-tight",
                                children: "Pol\xedticas y procedimientos"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Container__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                                maxWidth: "max-w-screen-lg",
                                className: "lg:px-24",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Lead__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    children: "Nos comprometemos a mantener la seguridad de sus datos, la privacidad de su informaci\xf3n privada y a ser transparentes sobre nuestras pr\xe1cticas como empresa."
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "py-10 lg:pb-20 bg-gradient-to-t from-gray-100 to-white",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Container__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "grid grid-cols-1 lg:grid-cols-12",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "lg:col-span-3",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "relative lg:sticky lg:top-32 z-10",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("nav", {
                                        className: "flex flex-col space-y-1 text-lg lg:py-10",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LegalNavigationLink, {
                                                href: "/legal/tos",
                                                isActive: router.pathname === "/legal/tos",
                                                children: "T\xe9rminos de servicio"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LegalNavigationLink, {
                                                href: "/legal/privacidad",
                                                isActive: router.pathname === "/legal/privacidad",
                                                children: "Pol\xedtica de privacidad"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LegalNavigationLink, {
                                                href: "/legal/cookies",
                                                isActive: router.pathname === "/legal/cookies",
                                                children: "Pol\xedtica de cookies"
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "lg:col-span-9 pt-10 divide-y",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                        className: "text-xl lg:text-4xl font-semibold tracking-tight pb-10",
                                        children: pageTitle
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "prose lg:prose-lg font-normal",
                                        children: children
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
};
LegalLayout.defaultProps = defaultProps;
LegalLayout.propTypes = propTypes;


/***/ }),

/***/ 42278:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Cookies; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _layouts_LegalLayout__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86402);


function Cookies() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "font-normal",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                children: "Introducci\xf3n"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                children: "Persona utiliza cookies y tecnolog\xedas similares en nuestro Sitio y Servicio para operar y administrar nuestro Sitio y el Servicio, recopilar datos de uso y rendimiento y brindarle una experiencia personalizada con Persona. Esto se describe en m\xe1s detalle a continuaci\xf3n."
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                children: "Esta Pol\xedtica de cookies proporciona informaci\xf3n sobre c\xf3mo y cu\xe1ndo usamos cookies y tecnolog\xedas similares y las opciones que tiene. Forma parte de la Pol\xedtica de privacidad de Persona. Los t\xe9rminos en may\xfascula utilizados en esta Pol\xedtica pero no definidos tienen el significado establecido en nuestra Pol\xedtica de privacidad, que tambi\xe9n incluye detalles sobre (i) por qu\xe9 y c\xf3mo Persona recopila, usa y almacena los Datos personales que recopilamos o recibimos a trav\xe9s del Sitio o el Servicio. , (ii) la base legal sobre la cual se procesan los Datos personales, y (iii) cu\xe1les son sus derechos y nuestras obligaciones en relaci\xf3n con sus Datos personales. Lea nuestra Pol\xedtica de privacidad para obtener informaci\xf3n sobre estos art\xedculos."
            })
        ]
    });
};
Cookies.layoutProps = {
    Layout: _layouts_LegalLayout__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z,
    pageTitle: "Pol\xedtica de cookies"
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(26010); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);